<template>
  <modal-dialog
    :visible="dialog"
    container-class="ma-0 pa-0"
    content-class="ma-0 pa-0"
    card-class="ma-0 pa-0"
    scrollable
    max-width="700"
    :title="title"
    @close="$emit('close')"
  >
    <guest-results-list
      :reservations="reservationsByDate"
      @close="handleUnsavedChanges"
    />

    <template #actions>
      <v-spacer />
      <v-btn
        color="primary"
        text
        @click="$emit('close')"
      >
        {{ $t('button.close' ) }}
      </v-btn>
    </template>
  </modal-dialog>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import DialogClosable from '@/mixins/dialog-closable';
import Reservation from '@/model/Reservation';
import Contact from '@/model/Contact';
import {
  mapByDateIndexToMapByDate, toSortedMapByDateIndex,
} from '@/services/reservations-utils';
import GuestResultsList from '@/components/views/guests/GuestResultsList.vue';

export default Vue.extend({
  name: 'ReservationResultsDialog',
  components: { GuestResultsList },
  mixins: [DialogClosable],
  props: {
    title: { type: String, required: false, default: '' },
    reservations: { type: Array as PropType<Reservation[] | null>, required: false, default: null },
  },
  data() {
    return { };
  },
  computed: {
    reservationsByDate(): Map<Date, Reservation[]> {
      const mapByDateIndex = toSortedMapByDateIndex(this.reservations ?? []);
      const mapByDate = mapByDateIndexToMapByDate(mapByDateIndex);
      return mapByDate;
    },
  },
  watch: { },
  methods: {
    handleUnsavedChanges(shouldClose: boolean) {
      if (shouldClose) { this.$emit('close'); }
    },
  },
});
</script>
